module.exports = __webpack_public_path__ + "static/media/logo184.46d5a078.png";